import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { AiCreativeAssetDownloadFailed } from "./errors";
/**
 * A single-endpoint sub-module for the asset proxy, following the same split
 * as {@link BrandKits}/{@link GenerateJobs} — `download` is the only real
 * operation, so find/save/delete stay unsupported.
 *
 * Fetches through the backend's proxy rather than the caller fetching
 * `assets[].url` directly: that signed GCS URL has no CORS headers, and a
 * direct fetch() would also skip axios's bearer-auth interceptor, saving a
 * 401 JSON body to disk as if it were the image.
 */
export default class Assets extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "aiCreative.assets");
    }
    downloadUrl(gcsKey) {
        return `${this.sdk.urls.creativeBaseUrl}/api/v1/creative/assets?key=${encodeURIComponent(gcsKey)}`;
    }
    async download(gcsKey) {
        try {
            const res = await axios.get(this.downloadUrl(gcsKey), { responseType: "blob" });
            return res.data;
        }
        catch (err) {
            throw new AiCreativeAssetDownloadFailed(err);
        }
    }
    async findItems() {
        throw new NotImplementedError("assets.find — an asset is downloaded by key, not looked up");
    }
    saveItem() {
        throw new NotImplementedError("save");
    }
    deleteItem() {
        throw new NotImplementedError("delete");
    }
}
//# sourceMappingURL=assets.js.map